<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">申込内容の確認</h2>
    </div>
    <div id="page-content" class="page-content">
      <Accordion :content="inputSummary" :isInitialOpen="true"></Accordion>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/medical-check" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <button id="nextButton" class="btn btn-danger rounded-pill" @click="register">
            申込を完了する
          </button>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
    <div id="loading" v-show="isShowDialog" class="page-content__overlay">
      <vue-loading
        v-show="isShowLoading"
        type="spiningDubbles"
        color="#fff"
        :size="{ width: '100px', height: '100px' }"
      ></vue-loading>
      <div id="content" v-show="isShowResult" class="page-content__overlay-contents">
        <article>
          <section>
            <div class="page-content__article-section-body--dialog-message">
              <p class="page-content__dialog-message--error">{{ this.resultMessage }}</p>
              <p>
                BSAC担当者まで上記メッセージまたはエラーコードをご連絡ください。<br />
                TEL: 03-5297-5656 / e-mail: training@bsac.jp
              </p>
            </div>
          </section>
        </article>
        <div class="page-footer__next-button-wrapper">
          <div class="page-footer__next-button-inner">
            <router-link to="/" custom v-slot="{ navigate }">
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
                トップ画面に戻る
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
  </div>
</template>

<script>
import Accordion from 'vues/common/components/parts/Accordion';
import { VueLoading } from 'vue-loading-template';

export default {
  components: {
    Accordion,
    VueLoading,
  },
  computed: {
    /**
     *
     */
    course: function () {
      let course = { name: '', price: '' };
      const selectedCourse = this.$store.getters['courseApplication/course'];

      if (!selectedCourse) return course;

      if (selectedCourse.name) {
        course.name = selectedCourse.name;
      }
      // if (selectedCourse.price) {
      //   course.price = '¥' + selectedCourse.priceWithTax.toLocaleString() + '（税込）';
      // }
      return course;
    },
    /**
     * 入力概要
     */
    inputSummary: function () {
      return this.$store.getters['courseApplication/inputSummary'];
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result = this.creditCardChecked || this.bankTransferChecked;
      return result;
    },
    /**
     * 結果メッセージ
     */
    resultMessage: function () {
      let message = null;
      if (this.registerResult === null) return message;

      message = this.registerResult.message + '\n\n';

      return message;
    },
  },
  data() {
    return {
      creditCardChecked: false,
      bankTransferChecked: false,
      isShowDialog: false,
      isShowLoading: false,
      isShowResult: false,
      payBy: null,
      registerResult: null,
    };
  },
  methods: {
    /**
     * 申込内容を登録する
     * 動的に遷移先を切り分けるためbeforeRouteLeaveメソッドは使わない
     */
    register: async function () {
      this.isShowDialog = true;
      this.isShowLoading = true;

      // エラーメッセージがセット済みの場合はトップ画面に遷移する
      if (
        this.$store.getters['courseApplication/registerResponse'] !== null &&
        this.$store.getters['courseApplication/registerResponse'].message !== null
      ) {
        this.$router.push('/');
      }

      // 登録する
      const res = await this.$store.dispatch('courseApplication/register');

      if (res.success && res.status === 201 && res.message === null) {
        // 完了画面に遷移する
        this.$router.push('/completed');
      }

      this.isShowLoading = false;
      this.isShowResult = true;
      this.registerResult = res;
    },
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      this.$store.commit('courseApplication/setPayBy', this.payBy);
    },
    /**
     * クレジットカード決済を選択する
     */
    selectCreditCard: function () {
      this.creditCardChecked = true;
      this.bankTransferChecked = false;
      this.saveDataInStore();
    },
    /**
     * 事前振込みを選択する
     */
    selectBankTransfer: function () {
      this.creditCardChecked = false;
      this.bankTransferChecked = true;
      this.saveDataInStore();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';
@import 'stylesheets/big-radio.scss';

.page-content__price-table {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;
  font-size: 0.8rem;
  text-align: center;
  vertical-align: middle;

  &-tr-title {
    width: 125px;
  }

  // &-tr-course {
  // }

  &-tr-price {
    font-size: 1.8rem;
    color: #ff0033;
  }
}

.page-content__creditcard-input-forms {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  height: auto;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;

  border-style: solid;
  border-width: 0.5px;
  border-radius: 1rem;
  box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.5);
}

.page-content__banktransfer-wrapper {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  height: auto;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;
}

.page-content__dialog-message--error {
  white-space: pre-wrap;
  color: red;
  font-weight: bold;
}
</style>
